import {FetchError} from 'ofetch';
import {useLogger, useRequestURL, useRuntimeConfig, useUniversalFetch} from '#imports';
import type {HostSettingsResource} from '../types';
import {hostSettingsUrl, type LocalePrefixConfig} from '../utils/hostSettingsUrl';

export function useHostSettings(): Promise<HostSettingsResource | undefined> {
    const logger = useLogger();
    const i18nConfig = useRuntimeConfig().public['@malt/nuxt-i18n-module'] as {supportedLocalePrefixes?: unknown} | undefined;
    const url = hostSettingsUrl(useRequestURL(), (i18nConfig?.supportedLocalePrefixes ?? []) as LocalePrefixConfig[]);

    return useUniversalFetch<HostSettingsResource>(url).catch((error: unknown) => {
        if (error instanceof FetchError) {
            logger.error(`Error while fetching host settings. Error: message=${error.message}, status=${error.statusCode}`);
        } else {
            logger.error('Error while fetching host settings', error);
        }
        return undefined;
    });
}
